import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';

/* Only in Draft status by creator or project manager */
export const cancelActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
    user: boolean = true,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/status?user=${user}`,
        'PATCH',
        JSON.stringify({
            processType: 'CANCEL_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Approved status by admin */
export const closeActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/status`,
        'PATCH',
        JSON.stringify({
            processType: 'CLOSE_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Closed status by admin */
export const reopenActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    completionDate: Date,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/status`,
        'PATCH',
        JSON.stringify({
            processType: 'REOPEN_AM',
            completionDate,
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Draft, Pending or Approved status by admin */
export const deactivateActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/status`,
        'PATCH',
        JSON.stringify({
            processType: 'DEACTIVATE_AM',
            commentMessage,
        }),
        commonHeaders,
    );

/* Only in Inactive status by admin */
export const reactivateActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    completionDate: Date,
    commentMessage?: string | null,
    user: boolean = true,
) =>
    callWebUtils(
        config,
        `/actionmemo/${amId}/status?user=${user}`,
        'PATCH',
        JSON.stringify({
            processType: 'REACTIVATE_AM',
            completionDate,
            commentMessage,
        }),
        commonHeaders,
    );
